import { isArray } from "@thi.ng/checks/is-array";
import { isNumber } from "@thi.ng/checks/is-number";
import { isProtoPath } from "@thi.ng/checks/is-proto-path";
import { isString } from "@thi.ng/checks/is-string";
import { illegalArgs } from "@thi.ng/errors/illegal-arguments";
const toPath = (path) => {
  if (isArray(path)) {
    if (!path.every((x) => isString(x) && x !== "" || isNumber(x)))
      __illegal(path);
    return path;
  } else {
    return isString(path) ? path.length > 0 ? toPath(path.split(".")) : [] : path != null ? [path] : [];
  }
};
const exists = (obj, path) => {
  if (obj == null) {
    return false;
  }
  path = toPath(path);
  for (let n = path.length - 1, i = 0; i <= n; i++) {
    const k = path[i];
    if (!obj.hasOwnProperty(k)) {
      return false;
    }
    obj = obj[k];
    if (obj == null && i < n) {
      return false;
    }
  }
  return true;
};
const disallowProtoPath = (path) => {
  const $path = toPath(path);
  if (isProtoPath($path)) __illegal(path);
  return $path;
};
const __illegal = (path) => illegalArgs(`illegal path: ${JSON.stringify(path)}`);
export {
  disallowProtoPath,
  exists,
  toPath
};
